import React, { useEffect } from 'react';
import { X } from 'lucide-react';

export default function Modal({ children, onClose, title }) {
  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, []);

  return (
    <div className="fixed inset-0 bg-black/50 flex items-end sm:items-center justify-center z-50 sm:p-4">
      <div className="bg-white w-full sm:rounded-2xl rounded-t-2xl shadow-xl sm:max-w-2xl sm:w-full max-h-[90vh] flex flex-col overflow-hidden">
        {/* Fixed Header */}
        <div className="bg-white border-b border-gray-200 px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between z-10 shrink-0">
          <h2 className="font-bold text-base sm:text-lg">{title}</h2>
          <button 
            onClick={onClose} 
            className="p-2 hover:bg-gray-100 active:bg-gray-200 rounded-lg transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        {/* Scrollable Body */}
        <div className="p-4 sm:p-6 overflow-y-auto overflow-x-hidden flex-1 overscroll-contain scrollbar-thin">
          {children}
        </div>
      </div>
    </div>
  );
}

